import React, { useState } from 'react';
import faqData from '../seo/faqItems';
import '../styles/HomeFaqSection.css';

// Shared with the build-time SEO script so the FAQPage structured data always matches the page.
const FAQ_ITEMS = faqData.FAQ_ITEMS;

const HomeFaqSection = () => {
  const [openId, setOpenId] = useState(null);

  const toggle = (id) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section className="home-faq" aria-labelledby="home-faq-heading">
      <div className="home-faq-container">
        <div className="home-faq-intro">
          <h2 id="home-faq-heading" className="home-faq-title">
            Frequently asked <span className="home-faq-title-accent">questions</span>
          </h2>
          <p className="home-faq-subtext">
            Got more questions? Feel free to{' '}
            <span className="home-faq-subtext-accent">contact us</span> on Discord or Live Chat!
          </p>
        </div>

        <div className="home-faq-list">
          {FAQ_ITEMS.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div key={item.id} className={`home-faq-item ${isOpen ? 'home-faq-item--open' : ''}`}>
                <button
                  type="button"
                  className="home-faq-trigger"
                  aria-expanded={isOpen}
                  aria-controls={`home-faq-panel-${item.id}`}
                  id={`home-faq-trigger-${item.id}`}
                  onClick={() => toggle(item.id)}
                >
                  <span className="home-faq-question">{item.question}</span>
                  <span className="home-faq-chevron" aria-hidden>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M6 9l6 6 6-6"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </button>
                <div
                  id={`home-faq-panel-${item.id}`}
                  role="region"
                  aria-labelledby={`home-faq-trigger-${item.id}`}
                  className="home-faq-panel"
                  aria-hidden={!isOpen}
                >
                  <div className="home-faq-panel-inner">
                    <p className="home-faq-answer">{item.answer}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HomeFaqSection;
